const StockType = {
    PADDLE: "paddle",
    SKI_JET: "ski-jet",
};

export default StockType;
